import { showToast } from "controls/global/stewart-toast";
import { bulkHoldPolicyTransaction } from "utils/api/policyTransactionApi";

// Place a policy transaction on hold via UpdateList, then toast the outcome.
// includeSameFileTran expands the hold to every record with the same Agent ID
// and File Name/Number (the "All matching records" scope).
export async function holdPolicyRecord(
  policyTransactionListID: string,
  reason: string,
  includeSameFileTran: boolean
): Promise<boolean> {
  const ok = await bulkHoldPolicyTransaction({
    PolicyTransactionListID: policyTransactionListID,
    OnHoldReason: reason,
    IncludeSameFileTran: includeSameFileTran ? 1 : 0,
    IsOnHold: 1,
  });
  showToast(
    ok
      ? { type: "success", message: "Policy has been placed on hold" }
      : { type: "error", message: "Failed to place the policy on hold" }
  );
  return ok;
}

export async function bulkHoldPolicyRecords(
  policyTransactionIDs: string[],
  reason: string,
  includeSameFileTran: boolean
): Promise<boolean> {
  const n = policyTransactionIDs.length;
  const label = `${n} record${n !== 1 ? "s" : ""}`;
  const ok = await bulkHoldPolicyTransaction({
    PolicyTransactionListID: policyTransactionIDs.join(","),
    OnHoldReason: reason,
    IncludeSameFileTran: includeSameFileTran ? 1 : 0,
    IsOnHold: 1,
  });
  showToast(
    ok
      ? { type: "success", message: `${label} placed on hold` }
      : { type: "error", message: `Failed to place ${label} on hold` }
  );
  return ok;
}

// Remove the hold from a policy transaction (reuses the hold API with IsOnHold: 0),
// then toast the outcome. includeSameFileTran mirrors the hold scope ("All
// matching records" vs "This record only").
export async function removeHoldPolicyRecord(
  policyTransactionListID: string,
  includeSameFileTran: boolean
): Promise<boolean> {
  const ok = await bulkHoldPolicyTransaction({
    PolicyTransactionListID: policyTransactionListID,
    OnHoldReason: "",
    IncludeSameFileTran: includeSameFileTran ? 1 : 0,
    IsOnHold: 0,
  });
  showToast(
    ok
      ? { type: "success", message: "Hold has been removed" }
      : { type: "error", message: "Failed to remove Hold" }
  );
  return ok;
}
